import React, { useEffect, useState } from "react";
import HoverGallery from "@components/Features/HoverGallery/HoverGallery";
import { PrimaryButton } from "@components/UI/Buttons/PrimaryButton/PrimaryButton";
import { numberWithSpaces } from "@src/utils/formatUtils";
import { OfferIcon } from "@features/catalog";
import { ProductPriceUsd } from "@features/product/product-price-usd";
import { ContactButton } from "@features/profile";
import { getCurrencySymbol, toRelativeTime } from "@shared/lib/utils";
import { VerticalCatalogCardMapProps } from "./types";
import classes from "../vertical-catalog-card/vertical-catalog-card.module.scss";

const VerticalCatalogCardMap = ({ offer }: VerticalCatalogCardMapProps) => {
    const [isDetailedInfoVisible, setIsDetailedInfoVisible] = useState(false);
    const offerAddress = [offer?.city, offer?.address].filter(Boolean).join(", ");
    const priceInCurrency = `${numberWithSpaces(offer?.price)} ${getCurrencySymbol(offer?.sourceId)}`;

    const ITEM_PROPS = [
        { label: "Трансмиссия", value: offer?.prepTransmission },
        { label: "Привод", value: offer?.prepDriveType },
        { label: "Кузов", value: offer?.prepBodyType },
        { label: "Цвет", value: offer?.prepColor }
    ];

    useEffect(() => {
        const isNoAdditionalData = !offer?.url && !offer?.prepPhone;
        setIsDetailedInfoVisible(isNoAdditionalData);
    }, [offer]);

    return (
        <div className={classes.VerticalCatalogCardMap}>
            <HoverGallery
                offer={offer}
                pics={offer?.imagesList}
                style={{
                    height: 215
                }}
            />
            <div className={classes.VerticalCardContent}>
                <div className={classes.VerticalCardNameContainer}>
                    <a
                        onClick={(event) => {
                            event.preventDefault();
                            window.open(`/product/${offer.id}`, "_blank");
                        }}
                        className={classes.VerticalCardName}
                        title={offer?.title}
                        href="#"
                    >
                        {offer?.title}
                    </a>
                </div>

                <div className={classes.Price}>
                    <span className={classes.Price__source}>{priceInCurrency}</span>
                    <ProductPriceUsd
                        className={classes.Price__usd}
                        priceUsd={offer?.priceUsd}
                        price={offer?.price}
                        sourceId={offer?.sourceId}
                    />
                </div>

                <div className={classes.Tags}>
                    <div>{offer?.year} г</div>
                    {offer?.mileage && <div>{numberWithSpaces(offer.mileage)} км</div>}
                </div>

                <div className={classes.Divider}></div>

                <div className={classes.Props}>
                    {ITEM_PROPS.map((item, index) => {
                        return (
                            <div className={classes.Prop} key={index}>
                                <div className={classes.PropLabel}>{item.label}</div>
                                <div className={classes.PropValue}>{item.value}</div>
                            </div>
                        );
                    })}
                </div>

                <div className={classes.Divider}></div>

                <div className={classes.Location}>
                    <svg
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="4" cy="4" r="4" fill="#5B8149" />
                    </svg>
                    {offerAddress}
                </div>

                <div className={classes.Divider}></div>

                <div className={classes.MapButtonsContainer}>
                    {!isDetailedInfoVisible && (
                        <PrimaryButton
                            type="Large"
                            onClick={() => {
                                setIsDetailedInfoVisible(true);
                            }}
                            content={"Подробнее"}
                        />
                    )}

                    {isDetailedInfoVisible && (
                        <div className={classes.DetailedInfo}>
                            {offer.prepPhone && <ContactButton phone={offer?.prepPhone} />}
                            {offer.url && (
                                <PrimaryButton
                                    type="Large"
                                    onClick={() => {
                                        window.open(offer.url, "_blank");
                                    }}
                                    content={"Перейти на сайт объявления"}
                                />
                            )}
                            <a
                                className={classes.LinkBtn}
                                href="#"
                                onClick={(event) => {
                                    event.preventDefault();
                                    window.open(`/product/${offer.id}`, "_blank");
                                }}
                            >
                                Подробнее об автомобиле
                            </a>
                        </div>
                    )}
                </div>

                <div className={classes.Footer}>
                    <OfferIcon className={classes.Footer_icon} sourceId={offer?.sourceId} />
                    <div className={classes.UpdatedTime}>{toRelativeTime(offer?.createdAt)}</div>
                </div>
            </div>
        </div>
    );
};
export default VerticalCatalogCardMap;